import { render, staticRenderFns } from "./items-table.vue?vue&type=template&id=7aaf990b&scoped=true&"
import script from "./items-table.vue?vue&type=script&lang=js&"
export * from "./items-table.vue?vue&type=script&lang=js&"
import style0 from "./items-table.vue?vue&type=style&index=0&id=7aaf990b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf990b",
  null
  
)

export default component.exports